import { PropsWithChildren, useMemo } from "react";
import { useToggle } from "react-use";

import { MatchCardContext } from "./match_card_context";
import { MatchCardContextProviderProps } from "./match_card_context.types";

export const MatchCardContextProvider = ({
  children,
  id,
  isCompressed,
  isShortlistTabActive,
  isOnMatchesTab = false,
  isUnbiasedMode,
  isProfileSelectedToCompare = false,
  addProfileToComparison,
  removeProfileFromComparison,
  ...matchCardProps
}: PropsWithChildren<MatchCardContextProviderProps>) => {
  const [animationTrigger, animate] = useToggle(false);

  const allowCompare = Boolean(addProfileToComparison && removeProfileFromComparison);

  const contextValue = useMemo(
    () => ({
      id,
      isCompressed: !!isCompressed,
      isUnbiasedMode: !!isUnbiasedMode,
      isShortlistTabActive,
      isOnMatchesTab,
      animationTrigger,
      animate,
      allowCompare,
      isProfileSelectedToCompare,
      addProfileToComparison,
      removeProfileFromComparison,
      ...matchCardProps
    }),
    [
      id,
      isCompressed,
      isShortlistTabActive,
      isOnMatchesTab,
      isUnbiasedMode,
      animationTrigger,
      animate,
      allowCompare,
      isProfileSelectedToCompare,
      addProfileToComparison,
      removeProfileFromComparison,
      matchCardProps
    ]
  );

  return <MatchCardContext.Provider value={contextValue}>{children}</MatchCardContext.Provider>;
};
